import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var SearchIcon = function SearchIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    strokeColor = _props.strokeColor,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.977 19.365",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: "none",
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#385cf6"),
    "stroke-linecap": "round",
    "stroke-width": "".concat((_d = attrs["stroke-width"]) !== null && _d !== void 0 ? _d : "2")
  }, [h("g", {
    fill: "#fff"
  }, [h("circle", {
    cx: 7.361,
    cy: 7.361,
    r: 7.631,
    stroke: "none"
  }), h("circle", {
    cx: 7.361,
    cy: 7.361,
    r: 6.631,
    fill: "none"
  })]), h("path", {
    fill: "none",
    d: "m11.656 13.043 4.907 4.907"
  })]));
};